import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs';
import {Api} from '../enum/Api';
import {map} from 'rxjs/operators';
import {ShopWindow} from '../model/shop-window';
import { ProductChange } from '../model/product-change';

@Injectable()
export class CatalogService {
  constructor(private httpService: HttpService) {}

  public getActiveDescomplicaCoupon(){
    return this.httpService.post('eCommercePME/shopWindow/getDescomplicaCoupon', Api.One_Portal,{});
  }

  public getProductsByClassification(productClassification: string, userId: string, validatedMitigation: boolean, couponIdentifier?: string, businessId?: string, checksumData?: any, typeSpecialMessage?: string, trustConsultationData?: any, typeWindow?: string): Observable<ShopWindow> {
    return this.httpService.post('eCommercePME/shopWindow/getProductsByClassification', Api.One_Portal,
      {productClassification: productClassification, coupon: couponIdentifier, userId: userId, businessId: businessId, checksumData: checksumData, validatedMitigation: validatedMitigation, typeSpecialMessage: typeSpecialMessage, trustConsultationData: trustConsultationData,typeWindow:typeWindow})
      .pipe(map(result => new ShopWindow(result)));
  }

  public getUpgradeProductsByClassification(productClassification: string, userId: string, validatedMitigation: boolean, couponIdentifier?: string, businessId?: string, checksumData?: any): Observable<ShopWindow> {
    return this.httpService.post('eCommercePME/shopWindow/getUpgradeProductsByClassification', Api.One_Portal,
      {productClassification: productClassification, coupon: couponIdentifier, userId: userId, businessId: businessId, checksumData: checksumData, validatedMitigation: validatedMitigation})
      .pipe(map(result => new ShopWindow(result)));
  }

  public getHybridProductsByClassification(productClassification: string, userId: string, validatedMitigation: boolean, businessId?: string, checksumData?: any, hybridPackage?: string): Observable<ShopWindow> {
    return this.httpService.post('eCommercePME/shopWindow/getHybridProductsByClassification', Api.One_Portal,
      {productClassification: productClassification, userId: userId, businessId: businessId, checksumData: checksumData, validatedMitigation: validatedMitigation, hybridPackage: hybridPackage})
      .pipe(map(result => new ShopWindow(result)));
  }

  public getProductsForChangePlan(userId: string, classification: string, businessId: string, type: string): Observable<Array<ProductChange>> {
    return this.httpService.post('eCommercePME/shopWindow/getUpgradeProducts', Api.One_Portal, {
      "productClassification": classification,
      "userId": userId,
      "businessId": businessId,
      "shopWindowType": type
    }).pipe(
      map((result: any) => {
        return result.upgradeShopWindowProducts.map((product: any) => new ProductChange(product));
      })
    );
  }

  public getProductForDisconnectedSale(productIdentifier): Observable<any> {
    return this.httpService.post('eCommercePME/shopWindow/getProductForDisconnectedSale', Api.One_Portal, {
      "productIdentifier": productIdentifier
    }).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

}
